'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper(underlying) {
  this.qq = null;
  this.qq = underlying;
}
export { $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper as $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper };
$p = $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype = new $j_java$002elang$002e$002dObject.$h_sc_AbstractIterator();
$p.constructor = $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JIteratorWrapper() {
}
export { $h_sc_convert_JavaCollectionWrappers$JIteratorWrapper as $h_sc_convert_JavaCollectionWrappers$JIteratorWrapper };
$h_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype = $p;
$p.i = (function() {
  return this.qq.i();
});
$p.e = (function() {
  return this.qq.e();
});
$p.f = (function(other) {
  if ((other instanceof $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper)) {
    var x = this.qq;
    var x$2 = other.qq;
    return ((x === null) ? (x$2 === null) : (x === x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this.qq);
});
function $isArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fb)));
}
export { $isArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper as $isArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper };
var $d_sc_convert_JavaCollectionWrappers$JIteratorWrapper = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sc_convert_JavaCollectionWrappers$JIteratorWrapper, "scala.collection.convert.JavaCollectionWrappers$JIteratorWrapper", ({
  fb: 1,
  u: 1,
  h: 1,
  i: 1,
  v: 1,
  a: 1
}));
export { $d_sc_convert_JavaCollectionWrappers$JIteratorWrapper as $d_sc_convert_JavaCollectionWrappers$JIteratorWrapper };
